import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["editor", "button", "status"]
    static values = {url: String}

    async generate(event) {
        event.preventDefault()
        if (!this.hasUrlValue || !this.hasEditorTarget) return

        if (this.currentHtml() && !window.confirm("Replace the current About content with an AI draft?")) return

        this.setLoading(true)
        this.setStatus("")

        try {
            const response = await fetch(this.urlValue, {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Accept": "application/json",
                    "X-CSRF-Token": this.csrfToken()
                }
            })
            const data = await response.json()

            if (!response.ok) throw new Error(data.error || "Could not generate About content.")
            if (!data.html) throw new Error("AI returned empty About content.")
            if (!this.editorTarget.editor) throw new Error("About editor is not ready yet.")

            this.editorTarget.editor.loadHTML(data.html)
            this.editorTarget.dispatchEvent(new Event("trix-change", {bubbles: true}))
            this.setStatus("Generated. Review and save.")
        } catch (error) {
            this.setStatus(error.message || "Could not generate About content.")
        } finally {
            this.setLoading(false)
        }
    }

    currentHtml() {
        const inputId = this.editorTarget.getAttribute("input")
        const input = inputId ? document.getElementById(inputId) : null
        return input?.value?.trim()
    }

    csrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.content || ""
    }

    setLoading(isLoading) {
        if (!this.hasButtonTarget) return

        this.buttonTarget.disabled = isLoading
        this.buttonTarget.classList.toggle("opacity-60", isLoading)
        this.buttonTarget.classList.toggle("cursor-wait", isLoading)
        this.buttonTarget.innerHTML = isLoading
            ? '<i data-lucide="loader-circle" class="w-4 h-4 animate-spin"></i> Generating...'
            : '<i data-lucide="wand-sparkles" class="w-4 h-4"></i> Generate with AI'

        if (window.lucide) window.lucide.createIcons()
    }

    setStatus(message) {
        if (this.hasStatusTarget) this.statusTarget.textContent = message
    }
}
